import CrmTracking from './crm_tracking';

export default CrmTracking;
